export const permissions = {
  ORGANIZATION: {
    READ: { key: 'ORGANIZATION_READ', description: 'Allows user to fetch and see organization data' },
    WRITE: { key: 'ORGANIZATION_WRITE', description: 'Allows user to create and modify organization data' },
  },
  ONBOARDING: {
    READ: { key: 'ONBOARDING_READ', description: 'Allows user to fetch and see onboarding data' },
    WRITE: { key: 'ONBOARDING_WRITE', description: 'Allows user to create and modify onboarding data' },
  },
  BROKER: {
    READ: { key: 'BROKER_READ', description: 'Allows user to fetch and see broker data' },
    WRITE: { key: 'BROKER_WRITE', description: 'Allows user to create and modify broker data' },
  },
  CUSTOMER: {
    READ: { key: 'CUSTOMER_READ', description: 'Allows user to fetch and see customer data' },
    WRITE: { key: 'CUSTOMER_WRITE', description: 'Allows user to create and modify customer data' },
  },
  POLICY: {
    READ: { key: 'POLICY_READ', description: 'Allows user to fetch and see policy data' },
    WRITE: { key: 'POLICY_WRITE', description: 'Allows user to create and modify policy data' },
  },
  PRODUCT_TYPE: {
    READ: { key: 'PRODUCT_TYPE_READ', description: 'Allows user to fetch and see product type data' },
    WRITE: { key: 'PRODUCT_TYPE_WRITE', description: 'Allows user to create and modify product type data' },
  },
  INSPECTION: {
    READ: { key: 'INSPECTION_READ', description: 'Allows user to fetch and see inspection data' },
    EDIT: { key: 'INSPECTION_EDIT', description: 'Allows user to modify inspection details' },
    CREATE: { key: 'INSPECTION_CREATE', description: 'Allows user to create new inspections' },
    DELETE: { key: 'INSPECTION_DELETE', description: 'Allows user to delete inspections' },
    REVIEW: { key: 'INSPECTION_REVIEW', description: 'Allows user to review, rate and reopen inspections' },
    SYNC: { key: 'INSPECTION_SYNC', description: 'Allows user to sync inspection data' },
    MARK_AS_PAID: { key: 'INSPECTION_MARK_AS_PAID', description: 'Allows user to mark inspections as paid' },
    SEND_REMINDERS: {
      key: 'INSPECTION_SEND_REMINDERS',
      description: 'Allows user to send inspection reminders to vendors/inspectors',
    },
    EXPORT: { key: 'INSPECTION_EXPORT', description: 'Allows user to export inspection data' },
    REPORT: { key: 'INSPECTION_REPORT', description: 'Allows user to open inspection reports' },
    CAN_ASSIGN: { key: 'INSPECTION_CAN_ASSIGN', description: 'Allows user to assign inspections.' },
    CAN_BE_ASSIGNED: { key: 'INSPECTION_CAN_BE_ASSIGNED', description: 'Allows user to be assigned to inspections.' },
    EXTERNAL_ACCESS: { key: 'INSPECTION_EXTERNAL_ACCESS', description: 'Allows user to access external endpoints' },
  },
  INSPECTION_VERSION: {
    READ: { key: 'INSPECTION_VERSION_READ', description: 'Allows user to fetch and see inspection version data' },
    WRITE: { key: 'INSPECTION_VERSION_WRITE', description: 'Allows user to create and modify inspection version data' },
  },
  INSPECTION_ITEM: {
    READ: { key: 'INSPECTION_ITEM_READ', description: 'Allows user to fetch and see inspection item data' },
    WRITE: { key: 'INSPECTION_ITEM_WRITE', description: 'Allows user to create and modify inspection item data' },
  },
  SECTION: {
    READ: { key: 'SECTION_READ', description: 'Allows user to fetch and see inspection section data' },
    WRITE: { key: 'SECTION_WRITE', description: 'Allows user to create and modify inspection section data' },
  },
  QUESTION: {
    READ: { key: 'QUESTION_READ', description: 'Allows user to fetch and see question data' },
    WRITE: {
      key: 'QUESTION_WRITE',
      description: 'Allows user to create and modify question data, except help content',
    },
    MANAGE_HELP: { key: 'QUESTION_MANAGE_HELP', description: 'Allows user to manage question help content' },
  },
  ANSWER: {
    READ: { key: 'ANSWER_READ', description: 'Allows user to fetch and see inspection answers' },
    WRITE: { key: 'ANSWER_WRITE', description: 'Allows user to create and modify inspection answers' },
  },
  FLAG: {
    READ: { key: 'FLAG_READ', description: 'Allows user to fetch and see flag data' },
    WRITE: { key: 'FLAG_WRITE', description: 'Allows user to create and modify basic flag data' },
    WRITE_DETAILS: {
      key: 'FLAG_WRITE_DETAILS',
      description: 'Allows user to modify flag details (violations/discrepancies)',
    },
    MANAGER: { key: 'FLAG_MANAGER', description: 'Allows user to open/use Flag Manager' },
  },
  IMAGE: {
    READ: { key: 'IMAGE_READ', description: 'Allows user to download and see images' },
    WRITE: { key: 'IMAGE_WRITE', description: 'Allows user to upload images' },
  },
  INSPECTOR: {
    READ: { key: 'INSPECTOR_READ', description: 'Allows user to fetch and see inspector data' },
    WRITE: { key: 'INSPECTOR_WRITE', description: 'Allows user to create and modify inspector data' },
    SEND_COMMAND: {
      key: 'INSPECTOR_SEND_COMMAND',
      description: `Allows user to send recovery commands to inspectors' devices`,
    },
    GENERATE_OTP: { key: 'INSPECTOR_GENERATE_OTP', description: `Allows user to access One Time Passwords` },
  },
  VENDOR: {
    READ: { key: 'VENDOR_READ', description: 'Allows user to fetch and see vendor data' },
    WRITE: { key: 'VENDOR_WRITE', description: 'Allows user to create and modify vendor data' },
  },
  HELP_CATEGORY: {
    READ: { key: 'HELP_CATEGORY_READ', description: 'Allows user to fetch and see help category data' },
    WRITE: { key: 'HELP_CATEGORY_WRITE', description: 'Allows user to create and modify help category data' },
  },
  HELP_SECTION: {
    READ: { key: 'HELP_SECTION_READ', description: 'Allows user to fetch and see help section data' },
    WRITE: { key: 'HELP_SECTION_WRITE', description: 'Allows user to create and modify help section data' },
  },
  HELP_PAGE: {
    READ: { key: 'HELP_PAGE_READ', description: 'Allows user to fetch and see help page data' },
    WRITE: { key: 'HELP_PAGE_WRITE', description: 'Allows user to create and modify help page data' },
  },
  FARM: {
    READ: { key: 'FARM_READ', description: 'Allows user to fetch and see farm data' },
    WRITE: { key: 'FARM_WRITE', description: 'Allows user to create and modify farm data' },
  },
  INSTERSECTION: {
    READ: { key: 'INSTERSECTION_READ', description: 'Allows user to fetch and see instersection data' },
  },
  RISK: {
    READ: { key: 'RISK_READ', description: 'Allows user to fetch and see risk calculation data' },
  },
  HAZARDHUB: {
    READ: { key: 'HAZARDHUB_READ', description: 'Allows user to fetch and see HazardHub data' },
  },
  SETTING: {
    READ: { key: 'SETTING_READ', description: 'Allows user to fetch and see settings' },
    WRITE: { key: 'SETTING_WRITE', description: 'Allows user to create and modify settings' },
  },
  USER: {
    READ: { key: 'USER_READ', description: 'Allows user to fetch and see user data' },
    WRITE: { key: 'USER_WRITE', description: 'Allows user to create and modify user data' },
  },
  ROLE: {
    READ: { key: 'ROLE_READ', description: 'Allows user to fetch and see role data' },
    WRITE: { key: 'ROLE_WRITE', description: 'Allows user to create and modify role data' },
  },
  PERMISSION: {
    READ: { key: 'PERMISSION_READ', description: 'Allows user to fetch and see permission data' },
  },
  SWAGGER: {
    READ: { key: 'SWAGGER_READ', description: 'Allows user to access internal API documentation (Swagger)' },
  },
  DEV_MODE: {
    TOGGLE: { key: 'DEV_MODE', description: 'Allows user to toggle "dev mode" on device' },
  },
  REC_LETTER: {
    READ: { key: 'REC_LETTER', description: 'Allows user to see the layout' },
  },
  BOX: {
    READ: { key: 'BOX_READ', description: 'Allows user to list, preview and download the files.' },
    UPLOAD: { key: 'BOX_UPLOAD', description: 'Allows user to upload files.' },
    WRITE: { key: 'BOX_WRITE', description: 'Allows user to modify and delete files.' },
  },
  REC_LETTER_EMAIL: {
    SEND: { key: 'REC_LETTER_EMAIL_SEND', description: 'Allows user send rec letter emails' },
  },
  SENDGRID_EVENT: {
    WRITE: { key: 'SENDGRID_EVENT_WRITE', description: 'Allows user to create sendgrid event entries.' },
    READ: { key: 'SENDGRID_EVENT_READ', description: 'Allows user to see sendgrid event entries.' },
  },
};

export interface Permission {
  key: string;
  description: string;
}
